import config from '@/config'
import path from 'path'

export default {
  methods: {
    assetPath(filepath) {
      const root = config.assetRoot || ''
      const relativePath = require(`assets/${filepath}`).replace(/^\//, '')
      return `${root}/${relativePath}`
    },
    assetSrcSet(src) {
      const dir = path.dirname(src)
      const ext = path.extname(src)
      const name = path.basename(src).replace(ext, '')
      return (
        this.assetPath(`${dir}/${name}${ext}`) +
        ' 1x, ' +
        this.assetPath(`${dir}/${name}@2x${ext}`) +
        ' 2x, ' +
        this.assetPath(`${dir}/${name}@3x${ext}`) +
        ' 3x'
      )
    },
  },
}
